import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SellToPharmacyDialogComponent } from './sell-to-pharmacy-dialog.component';
import { InputSearchScannerModule } from 'src/app/shared/components/input-search-scanner/input-search-scanner.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { SelectedNdcInputModule } from 'src/app/shared/components/selected-ndc-input/selected-ndc-input.module';



@NgModule({
  declarations: [SellToPharmacyDialogComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputModule,
    InputSearchScannerModule,
    ReactiveFormsModule,
    DialogModule,
    SelectedNdcInputModule
  ],
  exports: [SellToPharmacyDialogComponent]
})
export class SellToPharmacyDialogModule { }
